import SectionHeading from '../../components/SectionHeading';
import RichText from '../../components/RichText';

/**
 * AboutSection
 *
 * Renders the admin-managed "About Us" content (site settings `about`, a
 * sanitized rich-text HTML string) directly above the Contact/CTA section.
 * The heading is fixed in code; only the body comes from the CMS. When no
 * about content has been set, the whole section is hidden.
 */
function AboutSection({ settings }) {
  const about = (settings?.about || '').trim();

  if (!about) return null;

  return (
    <section className="about-bg" id="about">
      <div className="section-inner">
        <SectionHeading label="Who We Are" title="About Nation Wholesale" />
        <RichText html={about} className="about-text" />
      </div>
    </section>
  );
}

export default AboutSection;
